// 引入modal对话框
import { Modal } from 'iview';

// 图片弹框放大，自动根据屏幕大小设置宽高
export const showImageModal = (src, title = '图片') => {
  if (!src) {
    return;
  }

  // 获取屏幕宽度和高度，设置最大宽度和高度为屏幕宽高的 80%
  const screenWidth = window.innerWidth * 0.6;
  const screenHeight = window.innerHeight * 0.66;

  Modal.info({
    title: title, // 标题
    okText: '关闭', // 确认按钮内容
    width: screenWidth, // 动态宽度
    closable: true, // esc关闭
    scrollable: true, // 页面滚动
    maskClosable: true,
    render: (h) => {
      return h('div', {
        style: {
          width: `${screenWidth - 40}px`, // 减去padding后与弹框宽度一致
          height: `${screenHeight - 40}px`, // 减去padding后设置合适高度
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden', // 防止图片溢出
        }
      }, [
        h('img', {
          attrs: {
            src: src,
          },
          style: {
            'max-width': '100%',
            'max-height': '100%',
            'object-fit': 'contain', // 保持图片等比缩放
          }
        })
      ]);
    },
  });
};
